export default __webpack_public_path__ + "static/media/audio/cannon-shot-hit-explosion.e74fd71cd3e21dccccbbf433d1bde6cd.mp3";